export const customersData = [
  {
    customer_id: "CUST001",
    customer_name: "Amit Sharma",
    phone_number: "+91-9876543210",
    loan_account_id: "LN1001",
    product_type: "Personal Loan",
    loan_amount: 250000,
    emi_due_amount: 12400,
    due_date: "2025-06-15",
    dpd: 25,
    delinquency_status: "30+ DPD",
    credit_score_band: "650–700",
    last_emi_paid_date: "2025-05-10",
    last_paid_amount: 5000,
    ptp_history: "₹5,000 on 2025-06-20",
    fraud_flag: false,
    language_preference: "English",
    communication_consent: true,
    disposition_status: "",
    call_notes: "",
    next_follow_up_date: "2025-07-05",
    repayment_link_sent: true,
    waiver_requested: false,
  },
  {
    customer_id: "CUST002",
    customer_name: "Sonia Verma",
    phone_number: "+91-9876501234",
    loan_account_id: "LN1002",
    product_type: "Two-Wheeler Loan",
    loan_amount: 80000,
    emi_due_amount: 3200,
    due_date: "2025-06-20",
    dpd: 10,
    delinquency_status: "10+ DPD",
    credit_score_band: "700–750",
    last_emi_paid_date: "2025-05-20",
    last_paid_amount: 3200,
    ptp_history: "₹3,200 on 2025-06-25",
    fraud_flag: false,
    language_preference: "Hindi",
    communication_consent: true,
    disposition_status: "",
    call_notes: "",
    next_follow_up_date: "2025-07-10",
    repayment_link_sent: true,
    waiver_requested: false,
  },
  {
    customer_id: "CUST003",
    customer_name: "Rahul Mehta",
    phone_number: "+91-9876512345",
    loan_account_id: "LN1003",
    product_type: "Credit Card",
    loan_amount: 100000,
    emi_due_amount: 5500,
    due_date: "2025-06-10",
    dpd: 30,
    delinquency_status: "30+ DPD",
    credit_score_band: "600–650",
    last_emi_paid_date: "2025-04-10",
    last_paid_amount: 5000,
    ptp_history: "₹5,000 on 2025-06-15",
    fraud_flag: true,
    language_preference: "English",
    communication_consent: false,
    disposition_status: "",
    call_notes: "",
    next_follow_up_date: "2025-07-07",
    repayment_link_sent: false,
    waiver_requested: true,
  },
];

// Function to get all call logs flattened with customer info
export const getAllCallLogs = () => {
  const allLogs = [];

  customersData.forEach((customer) => {
    if (Array.isArray(customer.callLogs)) {
      customer.callLogs.forEach((log) => {
        allLogs.push({
          ...log,
          phone: customer.phone_number,
          caller: customer.customer_name,
          customer_id: customer.customer_id,
          loan_account_id: customer.loan_account_id,
          product_type: customer.product_type,
          emi_due_amount: customer.emi_due_amount,
          dpd: customer.dpd,
          delinquency_status: customer.delinquency_status,
          credit_score_band: customer.credit_score_band,
        });
      });
    }
  });

  return allLogs;
};

// Function to get customer by phone number or customer ID
export const getCustomerByPhone = (phoneNumber) => {
  return customersData.find(
    (customer) =>
      customer.phone_number === phoneNumber ||
      customer.customer_id === phoneNumber
  );
};

// Function to get all customers for the main table
export const getAllCustomers = () => {
  return customersData.map((customer) => ({
    ...customer,
    // Add any derived fields if needed
    overdue_bucket: getOverdueBucket(customer.dpd),
    status_color: getStatusColor(customer.delinquency_status),
  }));
};

// Helper function to determine overdue bucket
export const getOverdueBucket = (dpd) => {
  if (dpd === 0) return "Current";
  if (dpd <= 10) return "1-10 Days";
  if (dpd <= 30) return "11-30 Days";
  if (dpd <= 60) return "31-60 Days";
  if (dpd <= 90) return "61-90 Days";
  return "90+ Days";
};

// Helper function to get status color
export const getStatusColor = (status) => {
  if (status.includes("Current")) return "#22c55e";
  if (status.includes("10+ DPD")) return "#f59e0b";
  if (status.includes("30+ DPD")) return "#ef4444";
  if (status.includes("60+ DPD")) return "#dc2626";
  if (status.includes("90+ DPD")) return "#991b1b";
  return "#6b7280";
};

// Helper function to format currency
export const formatCurrency = (amount) => {
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
};

// Helper function to format date
export const formatDate = (dateString) => {
  if (!dateString) return "-";
  const date = new Date(dateString);
  return date.toLocaleDateString("en-IN");
};

// Function to get customers by various filters
export const getFilteredCustomers = (filters = {}) => {
  let filtered = [...customersData];

  if (filters.delinquency_status) {
    filtered = filtered.filter(
      (customer) => customer.delinquency_status === filters.delinquency_status
    );
  }

  if (filters.product_type) {
    filtered = filtered.filter(
      (customer) => customer.product_type === filters.product_type
    );
  }

  if (filters.dpd_range) {
    const { min, max } = filters.dpd_range;
    filtered = filtered.filter(
      (customer) => customer.dpd >= min && customer.dpd <= max
    );
  }

  return filtered;
};
